import { useEffect } from 'react';
import { useUIStore } from '@/store/uiStore';
import { cn } from '@/lib/cn';
import type { NotificationItem } from '@/types';

const typeStyles: Record<NotificationItem['type'], string> = {
  info: 'bg-bg-elevated/95 text-white border-accent/40',
  success: 'bg-success/15 text-success border-success/40',
  error: 'bg-danger/15 text-danger border-danger/40',
  warning: 'bg-gold/15 text-gold border-gold/40',
};

function NotificationToast({ item }: { item: NotificationItem }) {
  const dismiss = useUIStore((s) => s.dismissNotification);
  useEffect(() => {
    const t = setTimeout(() => dismiss(item.id), item.ttlMs ?? 3500);
    return () => clearTimeout(t);
  }, [item.id, item.ttlMs, dismiss]);
  return (
    <div
      className={cn(
        'px-4 py-3 rounded-xl border backdrop-blur-md shadow-card text-sm animate-slide-up',
        typeStyles[item.type],
      )}
      onClick={() => dismiss(item.id)}
    >
      {item.message}
    </div>
  );
}

export function Notifications() {
  const items = useUIStore((s) => s.notifications);
  if (items.length === 0) return null;
  return (
    <div
      className="fixed top-2 left-1/2 -translate-x-1/2 z-[90] flex flex-col gap-2 w-[min(420px,calc(100vw-2rem))]"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      {items.map((item) => (
        <NotificationToast key={item.id} item={item} />
      ))}
    </div>
  );
}
